<template>
  <ListButton
    :as="to ? 'a' : 'button'"
    :href="to"
    :selected="isActive"
    class="group"
    variant="primary"
  >
    <template #icon-before>
      <span class="h-1.5 w-1.5 rounded-full bg-brand-accent-blue"></span>
    </template>
    <span class="truncate"><slot /></span>
    <template #icon-after>
      <ArrowIcon
        class="hidden h-full w-4 place-self-center text-brand-accent-blue group-hover:block"
      />
    </template>
  </ListButton>
</template>

<script lang="ts" setup>
import ArrowIcon from '../../assets/arrow.svg'
import ListButton from '../ListButton/ListButton.vue'

defineProps<{
  color?: string
  isActive?: boolean
  to?: string
}>()
</script>
